import { NavigateNext } from '@mui/icons-material';
import { Breadcrumbs, Link, Skeleton, Stack, Typography } from '@mui/material';
import { distributorsContext } from 'pages/distributorManagement/distributorManagementResolver';
import { PropsWithChildren, useContext } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { ROUTES } from 'routing';
import { TableDataContext } from '../../shared/types';
import { DistributorsData } from '../../types/backend';
import { CurrentPricesActions } from './currentPricesActions';

type CurrentPricesLayoutProps = PropsWithChildren<{
    matchingCustomer: DistributorsData
}>

export function CurrentPricesLayout({ children, matchingCustomer }: CurrentPricesLayoutProps) {
    const summaryContext = useContext<TableDataContext<DistributorsData>>(distributorsContext);



    const breadcrumbs = [
        <Link component={RouterLink} underline='hover' key='1' color='black' to={ROUTES.distributorManagement}>
            <Typography color='text.primary' variant='h5'>
                Distributor Management
            </Typography>
        </Link>,

        <Typography key='2' color='text.primary' variant='h5'>
            {summaryContext.response?.isLoading ? (
                <Skeleton width={200} />
            ) : (
                `${matchingCustomer?.customerName} (${matchingCustomer?.customerNumber})`
            )}
        </Typography>,
        <Typography key='3' color='text.primary' variant='h5'>
            Pricing
        </Typography>,
    ];

    return (
        <Stack spacing={2} marginBottom={2}>
            <Breadcrumbs separator={<NavigateNext fontSize='small' />} aria-label='breadcrumb'>
                {breadcrumbs}
            </Breadcrumbs>
            <CurrentPricesActions />
            {children}
        </Stack>
    );
}
